module.exports = __webpack_public_path__ + "static/media/group-image.bd14c0c1.svg";